import { createRoute } from '@tanstack/react-router';
import { parsePujcovnaSpravaSearch } from '@/modules/pujcovna/helpers';
import { PujcovnaSpravaPage } from '@/modules/pujcovna/PujcovnaSpravaPage';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/sprava',
  component: PujcovnaSpravaPage,
  validateSearch: parsePujcovnaSpravaSearch,
});
